import { useEffect } from 'react';
import { loadRecaptcha } from '../../api';

/**
 * Adianta o download do reCAPTCHA v3 ao abrir a etapa de envio, para o clique em "Enviar" não
 * esperar o script. Uma falha aqui é ignorada: o envio tenta carregar de novo e, se não conseguir,
 * mostra o erro com o 0800.
 */
export function usePreloadRecaptcha(): void {
  useEffect(() => {
    loadRecaptcha().catch(() => undefined);
  }, []);
}
